/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".primary-background[_ngcontent-%COMP%]{background-color:var(--primary-color)!important;border-color:var(--primary-color)!important}.contact-us-bg[_ngcontent-%COMP%]{padding:20px;min-height:400px!important;line-height:50px}.contact-info[_ngcontent-%COMP%]{line-height:25px;font-size:18px;max-width:627px;padding:10px;border:1px solid!important;background:#0080000d;border-radius:5px;color:#000}"];
export { styles as styles };
